export const annaChwialkowska = {
    'firstName': 'Anna',
    'lastName': 'Chwiałkowska-Dąbkowska',
    'profession': 'Psycholog, psychoterapeuta w trakcie certyfikacji',
    'avatar': 'anna-chwialkowska-dabkowska.webp',
    'slug': 'psycholog-psychoterapeuta-anna-chwialkowska-dabkowska',
    'locations': ['torun'],
    'services': [
        ['psychology', 'consultation'],
        ['psychoterapy', 'adult']
    ]
}